import React from 'react';
import { Node } from '@uncinc/react-drupal-core';
import { PagerLoadMore } from '../../../components';

import './style.scss';

const GroupedContentDetailMore = ({ onLoadMore, pager, loading, entities, setCurrentPage, ...props }) => {
  const className = 'col-12 col-md-4 GroupedContentDetailMore__item-wrapper';
  const currentPage = pager.get('current_page');
  const totalPages = pager.get('total_pages');

  return (
    <div className="View GroupedContentThemeDetail">
      <div className="row no-gutters">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      <PagerLoadMore currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} onLoadMore={onLoadMore} />
    </div>
  );
};

export default GroupedContentDetailMore;
